import React from 'react';
import type { UIComponent } from '../schemas/base';
import { getRenderer } from '../registry/componentRegistry';
import { cn } from '../utils/cn';

interface ComponentRendererProps {
    component: UIComponent;
    onAction?: (action: string) => void;
    className?: string;
}

/**
 * Render a UI component based on its type
 * Dispatches to the correct renderer from the registry
 */
export function ComponentRenderer({ component, onAction, className }: ComponentRendererProps) {
    const Renderer = getRenderer(component.type);

    if (!Renderer) {
        console.warn(`No renderer found for component type: ${component.type}`);
        return (
            <div className={cn('rounded-lg border border-yellow-200 bg-yellow-50 p-4 text-sm text-yellow-800', className)}>
                Unknown component type: {component.type}
            </div>
        );
    }

    return (
        <Renderer
            component={component}
            onAction={onAction}
            className={className}
        />
    );
}
